import React from "react";
import { Constants } from "@/static/Constants";

export default function SubmitSuccess() {
    return (
        <div className="pof-wrapper">
            <div className="pof-card">
                <div className="pof-success">
                    <i className="pi pi-check-circle pof-success-icon" />
                    <h2>Request Submitted</h2>
                    <p>
                        Thank you. We have received your request and will respond as required
                        by law. If you have questions, contact us at{" "}
                        <a href={`mailto:${Constants.CONTACT_EMAIL}`}>
                            {Constants.CONTACT_EMAIL}
                        </a>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
}
